import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ba8fb962&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ba8fb962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8fb962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba8fb962')) {
      api.createRecord('ba8fb962', component.options)
    } else {
      api.reload('ba8fb962', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ba8fb962&scoped=true&", function () {
      api.rerender('ba8fb962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I2Dc2I9z5pZB/JS/comp/PopupBox.vue"
export default component.exports